import React from 'react';
import type { ArjSettingsFinancialYear as ArjSettingsFinancialYearType } from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/settings/financial-year/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

/**
 * Plans Settings - Financial Year
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyArjSettingsFinancialYear = lazyForPaint<typeof ArjSettingsFinancialYearType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-arj-settings-financial-year", jiraSpaEntry: "async-arj-settings-financial-year" */ '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/settings/financial-year'
			).then((module) => module.ArjSettingsFinancialYear),
		),
	{ ssr: false },
);

export const ArjSettingsFinancialYear = (): React.JSX.Element => (
	<LazyPage
		Page={LazyArjSettingsFinancialYear}
		pageId="arj-settings-financial-year"
		shouldShowSpinner
	/>
);
